/*

*/
import React from 'react'

const GoogleIcon = (props) => {
    const { name = "", size = "s", color = '#fff', className = "" } = props;

    return (
        <svg className={('icon', name) + " " + className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" fill="white" />
            <path d="M6.98918 13.8775L6.36263 16.2166L4.07258 16.265C3.3882 14.9956 3 13.5433 3 11.9999C3 10.5075 3.36295 9.10012 4.00631 7.8609H4.0068L6.04559 8.23468L6.9387 10.2612C6.75177 10.8062 6.64989 11.3912 6.64989 11.9999C6.64996 12.6606 6.76963 13.2936 6.98918 13.8775Z" fill="#FBBB00" />
            <path d="M20.8422 10.3191C20.9455 10.8635 20.9994 11.4258 20.9994 12.0004C20.9994 12.6447 20.9317 13.2733 20.8026 13.8795C20.3645 15.9426 19.2197 17.7441 17.6338 19.0189L17.6333 19.0184L15.0654 18.8874L14.7019 16.6186C15.7542 16.0015 16.5766 15.0357 17.0098 13.8795H12.1973V10.3191H20.8422Z" fill="#518EF8" />
            <path d="M17.6336 19.0179L17.6341 19.0184C16.0917 20.2581 14.1325 20.9999 11.9997 20.9999C8.57227 20.9999 5.59239 19.0842 4.07227 16.265L6.98886 13.8776C7.74891 15.906 9.70567 17.35 11.9997 17.35C12.9857 17.35 13.9095 17.0834 14.7021 16.6181L17.6336 19.0179Z" fill="#28B446" />
            <path d="M17.7442 5.07197L14.8286 7.45894C14.0082 6.94615 13.0385 6.64992 11.9995 6.64992C9.65361 6.64992 7.66025 8.16013 6.93828 10.2613L4.00635 7.86099H4.00586C5.50373 4.97307 8.52119 3 11.9995 3C14.1833 3 16.1855 3.77787 17.7442 5.07197Z" fill="#F14336" />
        </svg>
    )
};

export default GoogleIcon
